import { render } from "./WebcamCapture.vue?vue&type=template&id=6deaf45e&scoped=true"
import script from "./WebcamCapture.vue?vue&type=script&lang=js"
export * from "./WebcamCapture.vue?vue&type=script&lang=js"

import "./WebcamCapture.vue?vue&type=style&index=0&id=6deaf45e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deaf45e"]])

export default __exports__